import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  wrapper: {
    marginTop: '6px',
  },
  divider: {
    borderColor: '#FEFEFEAA',
    marginTop: '7px',
  },
});
